import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, getDocs, doc, getDoc, setDoc, updateDoc, deleteDoc, query, where, orderBy, onSnapshot, serverTimestamp } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// --- Lazy-loaded Auth ---
// Instead of loading firebase/auth (and its iframe.js) on every page load,
// we only load it when getAuthInstance() or getGoogleProvider() is actually called.
let _auth = null;
let _googleProvider = null;

export const getAuthInstance = async () => {
  if (!_auth) {
    const { getAuth } = await import("firebase/auth");
    _auth = getAuth(app);
  }
  return _auth;
};

export const getGoogleProvider = async () => {
  if (!_googleProvider) {
    const { GoogleAuthProvider } = await import("firebase/auth");
    _googleProvider = new GoogleAuthProvider();
  }
  return _googleProvider;
};

export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_placeholder";

export const fmt = (n) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(n);
};

export const uid = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const date = new Date(iso);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return fmtDate(iso);
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

export const statusBadge = (status) => {
  const map = {
    Pending: { class: "badge-pending", label: "Pending" },
    Paid: { class: "badge-paid", label: "Paid" },
    Completed: { class: "badge-completed", label: "Completed" },
    Cancelled: { class: "badge-cancelled", label: "Cancelled" }
  };
  return map[status] || { class: "badge-pending", label: status };
};

export { collection, addDoc, getDocs, doc, getDoc, setDoc, updateDoc, deleteDoc, query, where, orderBy, onSnapshot, serverTimestamp };